var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    attrs: {
      "width": "800",
      "title": _vm.currentSalesCost.customer ? _vm.currentSalesCost.customer.name : ''
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('div', {
    staticClass: "drawer-wrap"
  }, [_c('div', {
    staticClass: "drawer-contetn"
  }, [_c('div', {
    staticClass: "basic-info"
  }, [_c('div', {
    staticClass: "copy-button"
  }, [_c('Button', {
    staticClass: "btn",
    attrs: {
      "long": "",
      "disabled": _vm.currentSalesCost.calcSalesCost ? false : true,
      "data-clipboard-text": _vm.con
    },
    on: {
      "click": function ($event) {
        return _vm.copy(_vm.currentSalesCost);
      }
    }
  }, [_vm._v(" 复制数据 ")])], 1), _c('div', {
    staticClass: "basicInfo-item"
  }, [_c('div', [_vm._v("销售简称")]), _c('div', {
    staticClass: "basicInfo-item-data"
  }, [_vm._v(" " + _vm._s(_vm.currentSalesCost.abbr ? _vm.currentSalesCost.abbr : "") + " ")])]), _c('div', {
    staticClass: "basicInfo-item"
  }, [_c('div', [_vm._v("材料名称")]), _c('div', {
    staticClass: "basicInfo-item-data"
  }, [_vm._v(" #" + _vm._s(_vm.currentSalesCost.material ? _vm.currentSalesCost.material.model : "") + "- " + _vm._s(_vm.currentSalesCost.material ? _vm.currentSalesCost.material.name : "") + " ")])]), _c('div', {
    staticClass: "basicInfo-item"
  }, [_c('div', [_vm._v("配方名称")]), _c('div', {
    staticClass: "basicInfo-item-data"
  }, [_vm._v(" #" + _vm._s(_vm.currentSalesCost.prodRecipe ? _vm.currentSalesCost.prodRecipe.NoId : "") + " " + _vm._s(_vm.currentSalesCost.prodRecipe ? _vm.currentSalesCost.prodRecipe.name : "") + " ")])]), _c('div', {
    staticClass: "basicInfo-item"
  }, [_c('div', [_vm._v("核算日期")]), _c('div', {
    staticClass: "basicInfo-item-data"
  }, [_vm._v(" " + _vm._s(_vm.currentSalesCost.createdAt) + " ")])]), _c('div', {
    staticClass: "basicInfo-item"
  }, [_c('div', [_vm._v("生产工厂")]), _c('div', {
    staticClass: "basicInfo-item-data"
  }, [_vm._v(" " + _vm._s(_vm.currentSalesCost.factory ? _vm.currentSalesCost.factory.name : "") + " ")])]), _c('div', {
    staticClass: "basicInfo-item"
  }, [_c('div', [_vm._v("材料成本")]), _c('div', {
    staticClass: "basicInfo-item-data"
  }, [_vm._v(" " + _vm._s(_vm.adjustNumber(_vm.currentSalesCost, "calcSalesCost.materialCost")) + " ")])]), _c('div', {
    staticClass: "basicInfo-item"
  }, [_c('div', [_vm._v("运费")]), _c('div', {
    staticClass: "basicInfo-item-data"
  }, [_vm._v(" " + _vm._s(_vm.adjustNumber(_vm.currentSalesCost, "calcSalesCost.transCost")) + " ")])]), _c('div', {
    staticClass: "basicInfo-item"
  }, [_c('div', [_vm._v("业务费")]), _c('div', {
    staticClass: "basicInfo-item-data"
  }, [_vm._v(" " + _vm._s(_vm.adjustNumber(_vm.currentSalesCost, "calcSalesCost.promoFee")) + " ")])]), _c('div', {
    staticClass: "basicInfo-item"
  }, [_c('div', [_vm._v("复配费")]), _c('div', {
    staticClass: "basicInfo-item-data"
  }, [_vm._v(" " + _vm._s(_vm.adjustNumber(_vm.currentSalesCost, "calcSalesCost.manufactCost")) + " ")])]), _c('div', {
    staticClass: "basicInfo-item"
  }, [_c('div', [_vm._v("税费")]), _c('div', {
    staticClass: "basicInfo-item-data"
  }, [_vm._v(" " + _vm._s(_vm.adjustNumber(_vm.currentSalesCost, "calcSalesCost.tax")) + " ")])]), _c('div', {
    staticClass: "basicInfo-item"
  }, [_c('div', [_vm._v("合计成本")]), _c('div', {
    staticClass: "basicInfo-item-data"
  }, [_vm._v(" " + _vm._s(_vm.adjustNumber(_vm.currentSalesCost, "calcSalesCost.totalCost")) + " ")])]), _c('div', {
    staticClass: "basicInfo-item"
  }, [_c('div', [_vm._v("售价")]), _c('div', {
    staticClass: "basicInfo-item-data"
  }, [_vm._v(" " + _vm._s(_vm.adjustNumber(_vm.currentSalesCost, "calcSalesCost.price")) + " ")])]), _c('div', {
    staticClass: "basicInfo-item"
  }, [_c('div', [_vm._v("利润")]), _c('div', {
    staticClass: "basicInfo-item-data"
  }, [_vm._v(" " + _vm._s(_vm.adjustNumber(_vm.currentSalesCost, "calcSalesCost.profit")) + " ")])]), _c('div', {
    staticClass: "basicInfo-item"
  }, [_c('div', [_vm._v("利润率")]), _c('div', {
    staticClass: "basicInfo-item-data"
  }, [_vm._v(" " + _vm._s(_vm.adjustNumber(_vm.currentSalesCost, "calcSalesCost.profitRate", "%")) + " ")])]), _c('div', {
    staticClass: "basicInfo-item"
  }, [_c('div', [_vm._v("账期（月）")]), _c('div', {
    staticClass: "basicInfo-item-data"
  }, [_vm._v(" " + _vm._s(_vm.adjustNumber(_vm.currentSalesCost, "calcSalesCost.estAging")) + " ")])]), _c('div', {
    staticClass: "basicInfo-item"
  }, [_c('div', [_vm._v("资金成本")]), _c('div', {
    staticClass: "basicInfo-item-data"
  }, [_vm._v(" " + _vm._s(_vm.adjustNumber(_vm.currentSalesCost, "calcSalesCost.agingCost")) + " ")])]), _c('div', {
    staticClass: "basicInfo-item"
  }, [_c('div', [_vm._v("合计成本(含资)")]), _c('div', {
    staticClass: "basicInfo-item-data"
  }, [_vm._v(" " + _vm._s(_vm.adjustNumber(_vm.currentSalesCost, "calcSalesCost.totalCostWithAging")) + " ")])]), _c('div', {
    staticClass: "basicInfo-item"
  }, [_c('div', [_vm._v("利润(含资)")]), _c('div', {
    staticClass: "basicInfo-item-data"
  }, [_vm._v(" " + _vm._s(_vm.adjustNumber(_vm.currentSalesCost, "calcSalesCost.profitAfterAging")) + " ")])]), _c('div', {
    staticClass: "basicInfo-item"
  }, [_c('div', [_vm._v("利润率(含资)")]), _c('div', {
    staticClass: "basicInfo-item-data"
  }, [_vm._v(" " + _vm._s(_vm.adjustNumber(_vm.currentSalesCost, "calcSalesCost.profitRateAfterAging", "%")) + " ")])]), _c('div', {
    staticClass: "basicInfo-item"
  }, [_c('div', [_vm._v("年收益率")]), _c('div', {
    staticClass: "basicInfo-item-data"
  }, [_vm._v(" " + _vm._s(_vm.adjustNumber(_vm.currentSalesCost, "calcSalesCost.annualizedRateOfReturns", "%")) + " ")])])]), _c('div', {
    staticClass: "material-table"
  }, [_c('Table', {
    attrs: {
      "border": "",
      "loading": _vm.tableLoading,
      "columns": _vm.columns,
      "data": _vm.prodRecipe.materialCostDetail
    }
  })], 1)])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }